import React, { ButtonHTMLAttributes, forwardRef, HTMLAttributes } from 'react';

import classNames from 'classnames';

import LoadingSpinner from '../components/LoadingSpinner';

import './ButtonGroup.scss';

type ButtonGroupProps = HTMLAttributes<HTMLDivElement> & {
    readonly size: 'sm' | 'md' | 'lg';
    readonly boldSublabel?: boolean;
};

export const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(
    ({ className, size, boldSublabel, ...props }, ref) => {
        const classNameString = classNames(
            'button-group',
            `button-group--${size}`,
            boldSublabel ? 'bold-sublabel' : '',
            className
        );
        return <div {...props} ref={ref} className={classNameString} />;
    }
);

type GroupButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
    readonly icon?: string;
    readonly label: string;
    readonly subLabel?: string;
    readonly loading?: boolean;
    readonly state?: 'disabled' | 'clickable' | 'not-clickable';
    readonly result?: 'success' | 'failure';
};

export const GroupButton = forwardRef<HTMLButtonElement, GroupButtonProps>(
    ({ className, icon, label, subLabel, loading, state = 'clickable', result, ...props }, ref) => {
        return (
            <button
                {...props}
                ref={ref}
                className={classNames(
                    'group-button',
                    `group-button--${state}`,
                    loading && 'group-button--loading',
                    result && `group-button--${result}`,
                    className
                )}
            >
                {loading ? (
                    <LoadingSpinner width={22} />
                ) : (
                    <>
                        <span className="group-button-label">
                            {icon && <i className="material-icons">{icon}</i>}
                            {label}
                        </span>
                        {subLabel && <span className="group-button-sublabel">{subLabel}</span>}
                    </>
                )}
            </button>
        );
    }
);
